<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
========================================================================================== -->


<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js"; 

export default {
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    }
  },
  methods: {
    // Correctif app-wide : vuesax vs-select ne se ferme pas au clic extérieur.
    // On écoute MOUSEDOWN (capture) et PAS click : Chromium cible désormais le click sur l'ANCÊTRE COMMUN
    // de mousedown/mouseup — or le panneau .vs-select--options est monté dans <body> (insertBody vuesax),
    // donc dès qu'il s'ouvre sous le curseur, la cible du click devient <body> et un handler click
    // refermait le select à l'instant même de son ouverture (bug Chrome/Edge). mousedown, lui, cible
    // toujours l'élément réellement pressé ET se déclenche AVANT le focus qui ouvre le select cliqué.
    closeOpenVsSelects(e) {
      const target = e.target instanceof Element ? e.target : null;
      // Clic dans un panneau d'options (porté par <body>) : laisser vuesax gérer la sélection/fermeture.
      if (target && target.closest(".vs-select--options")) return;
      const selects = document.querySelectorAll(".con-select");
      for (let i = 0; i < selects.length; i++) {
        const el = selects[i];
        const vm = el.__vue__;
        if (vm && vm.active && typeof vm.closeOptions === "function" && !(target && el.contains(target))) {
          vm.closeOptions();
        }
      }
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    document.addEventListener("mousedown", this.closeOpenVsSelects, true);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.closeOpenVsSelects, true);
  }
};
</script>
